import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';


export const shopFloorDisplaySettingsApi = createApi({
    reducerPath: "shopFloorDisplaySettings",
    tagTypes: ['ShopFloorDisplaySettings'],
    baseQuery: createCustomFetchBaseQuery(),
    endpoints: (builder) => ({
        getShopFloorDisplaySettings: builder.query({
            query: ({pageno}) => {
                let url = `admin/shop-floor-display?pageno=${pageno + 1}`;
                return {
                    url: url,
                    method: 'GET',
                }
            },
            providesTags: ['ShopFloorDisplaySettings'],
        }),
        updateShopFloorDisplaySettings:builder.mutation({
            query: (data) => ({
                url: `admin/shop-floor-display-settings`,
                method: 'PUT',
                body: data
            }),
            invalidatesTags: ['ShopFloorDisplaySettings'],
        }),
        updateShopFloorDisplayToken:builder.mutation({
            query: (data) => ({
                url: `admin/shop-floor-display-revoke-token`,
                method: 'PUT',
                body: data
            }),
            invalidatesTags: ['ShopFloorDisplaySettings'],
        }),
        getShopFloorBuilds : builder.query({
            query: ({token , page , limit}) => {
                let url = `admin/shop-floor-display/token/builds?token=${token}&page=${page}&limit=${limit}`;
                return {
                    url: url,
                    method: 'GET',
                }
            },
        }),
        verifyShopFloorPasscode : builder.mutation({
            query: (data) => ({
                url: `admin/shop-floor-display/verify-passcode`,
                method: 'POST',
                body: data
            }),
          })
        })
});

export const {
    useGetShopFloorDisplaySettingsQuery,
    useUpdateShopFloorDisplaySettingsMutation,
    useUpdateShopFloorDisplayTokenMutation,
    useGetShopFloorBuildsQuery,
    useVerifyShopFloorPasscodeMutation
} = shopFloorDisplaySettingsApi